import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import TalentListPage from '../components/Talent/TalentListPage'
import { stages as stageService } from '../services/apiService'

/**
 * CandidatesByStage
 *
 * Один общий компонент под /candidates/:stageKey — раньше на каждую стадию
 * воронки заводился отдельный файл-страница (Video.jsx, Interview.jsx,
 * Onboarding.jsx), и добавление новой стадии в воронку требовало руками
 * писать новую страницу + роут + пункт меню. Список стадий и пункты меню
 * (см. Layout.jsx) теперь строятся из данных (GET /stages?talent_type=candidate),
 * так что новая стадия воронки появляется здесь сама, без правок кода.
 *
 * Фильтрует по стадии (stageKeys), а не по имени статуса — кандидат остаётся
 * виден на странице своей стадии независимо от статуса на ней (Approved,
 * Denied...), а не только пока статус называется буквально как стадия.
 */
const CandidatesByStage = () => {
  const { stageKey } = useParams()
  const [stage, setStage] = useState(null)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    let cancelled = false
    setStage(null)
    setNotFound(false)

    stageService.getStages({ talent_type: 'candidate' })
      .then((res) => {
        if (cancelled) return
        const list = Array.isArray(res?.data) ? res.data : []
        const found = list.find((s) => s.key === stageKey)
        if (found) {
          setStage(found)
        } else {
          setNotFound(true)
        }
      })
      .catch((err) => {
        console.error('Error loading stage for candidates page:', err)
        if (!cancelled) setNotFound(true)
      })

    return () => { cancelled = true }
  }, [stageKey])

  if (notFound) {
    return (
      <div className="text-center py-12">
        <h2 className="text-lg font-medium text-light-text-primary dark:text-dark-text-primary mb-2">Stage not found</h2>
        <p className="text-light-text-tertiary dark:text-dark-text-tertiary">
          "{stageKey}" isn't a known candidate pipeline stage.
        </p>
      </div>
    )
  }

  return (
    <>
      <title>{stage ? `${stage.name} | Talent Service` : 'Candidates | Talent Service'}</title>
      <TalentListPage
        talentType="candidate"
        stageKeys={stageKey}
        pageTitle={stage ? `${stage.name} Candidates` : undefined}
        pageDescription={
          stage
            ? (stage.description
                ? `${stage.description} — includes candidates in any status while on this stage`
                : `Candidates at the ${stage.name} stage — includes candidates in any status while on this stage`)
            : undefined
        }
      />
    </>
  )
}

export default CandidatesByStage
